import React, { useState } from "react";
import NewsletterSubscribe from '~/components/molecules/NewsletterSubscribe';
import FadeInWhenVisible from '~/components/FadeInWhenVisible'

export default function Newsletter({heading = 'Subscribe today', content = 'Sign up to City Relay and be the first to hear about new content and upcoming events.', key, index, ...props}) {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const section = props?.newsletter

  return (
    <section className="bg-navy py-24 text-white">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center">
          <FadeInWhenVisible>
            <h3 className="text-h3 mb-6 newsletter-heading">{!isSubmitted ? (section?.heading ? section.heading : heading) : 'Thank you for joining our newsletter'}</h3>
          </FadeInWhenVisible>

          {!isSubmitted && (
            <>
              <FadeInWhenVisible>
                <p className="text-white text-opacity-80 mb-8 newsletter-body">{section?.content ? section?.content : content}</p>
              </FadeInWhenVisible>

              <div className="w-full transition-opacity duration-200">
                <NewsletterSubscribe setIsSubmitted={setIsSubmitted} centered />
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
